import { useParams, Link } from 'react-router-dom';
import { products } from '@/mocks/products';
import ScrollReveal from '@/components/base/ScrollReveal';
import ImageGallery from './components/ImageGallery';
import ProductInfo from './components/ProductInfo';
import ProductAccordions from './components/ProductAccordions';
import YouMayAlsoLike from './components/YouMayAlsoLike';

export default function ProductDetail() {
  const { slug } = useParams<{ slug: string }>();
  const product = products.find((p) => p.slug === slug);

  if (!product) {
    return (
      <main>
        <section className="min-h-[60vh] flex flex-col items-center justify-center bg-background-50 px-4 text-center">
          <div className="w-16 h-16 flex items-center justify-center mb-4">
            <i className="ri-error-warning-line text-3xl text-foreground-300"></i>
          </div>
          <h1 className="text-2xl font-heading font-bold text-primary-500 mb-2">
            Product Not Found
          </h1>
          <p className="text-sm text-foreground-500 font-label mb-6">
            We couldn&apos;t find the product you&apos;re looking for.
          </p>
          <Link
            to="/shop"
            className="px-6 py-3 rounded-xl font-label font-semibold text-sm bg-accent-500 text-primary-800 hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            Browse All Products
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main>
      {/* Product section */}
      <section className="bg-background-50 py-8 md:py-12">
        <div className="max-w-none mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 xl:gap-16">
            {/* Left: Image Gallery */}
            <ScrollReveal direction="left" className="w-full lg:w-[52%] xl:w-[55%]">
              <ImageGallery images={product.images} productName={product.name} />
            </ScrollReveal>

            {/* Right: Product Info + Accordions */}
            <div className="w-full lg:w-[48%] xl:w-[45%] flex flex-col gap-6">
              <ScrollReveal direction="right">
                <ProductInfo product={product} />
              </ScrollReveal>
              <ScrollReveal delay={200}>
                <ProductAccordions
                  details={product.details}
                  careInstructions={product.careInstructions}
                />
              </ScrollReveal>
            </div>
          </div>
        </div>
      </section>

      {/* You May Also Like */}
      <YouMayAlsoLike currentProduct={product} />
    </main>
  );
}